<app-default-layout></app-default-layout>
<router-outlet></router-outlet>

<div
class="toast-container position-fixed top-0 end-0 p-3"
style="z-index: 1100"
>
<ngb-toast
  *ngFor="let toast of toastService.getToasts()"
  [autohide]="toast.options?.autohide ?? true"
  [delay]="toast.options?.delay ?? 5000"
  [class]="toast.options?.classname"
  (hidden)="toastService.remove(toast)"
>
  <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
    <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
  </ng-template>
  <ng-template #text>{{ toast.textOrTpl }}</ng-template>
</ngb-toast>
</div>
